import type { RAsyncComboBoxProps } from './async-combo-box';
import { AsyncComboBox } from './async-combo-box';

import { FormItem, FormMessage } from '../form';

type LocalFormComboboxProps<T, isMulti extends boolean> = RAsyncComboBoxProps<T, isMulti> & {
  formItemClassName?: string;
  forceHideMessage?: boolean;
  getRef?: (ref: HTMLInputElement | null) => void; // Generic HTML input reference
};
export type FormAsyncComboboxProps<T, isMulti extends boolean = false> = Omit<
  LocalFormComboboxProps<T, isMulti>,
  'useApi' | 'itemToString' | 'keyExtractor'
>;

export function FormAsyncCombobox<T, isMulti extends boolean = false>({
  formItemClassName,
  forceHideMessage = false,
  ...props
}: LocalFormComboboxProps<T, isMulti>) {
  return (
    <FormItem className={formItemClassName}>
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <AsyncComboBox {...props} />
      }

      {!forceHideMessage && <FormMessage title={typeof props.label === 'string' ? props.label : undefined} />}
    </FormItem>
  );
}
